module.exports = __webpack_public_path__ + "img/IMG_2729_L_WoodMatted_MockedUp.7dd04b29.jpg";